import { useTranslation } from "react-i18next";
import Button from "shared/UI/Buttons/Button";

interface RecommendedResourceCoachmarkProps {
  step: number;
  totalSteps: number;
  onDone: () => void;
}

export const RecommendedResourceCoachmark = ({ step, totalSteps, onDone }: RecommendedResourceCoachmarkProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: "supportMoments.recommendedResource.coachmark" });

  return (
    <div className="space-y-2 p-3 max-w-[355px] lg:w-[327px]">
      <h3 className="!text-lg">{t("heading")}</h3>
      <p className="text-lg">{t("body")}</p>
      <div className="flex items-center justify-between pt-6">
        <span>{t("stepIndicator", { current: step, count: totalSteps })}</span>
        <Button type="button" onClick={onDone} variant="secondary" className="rounded-full !w-[90px] !h-[35px]" text={t("done")} />
      </div>
    </div>
  );
};
